// Inline loading spinner. Inherits the parent's text colour (border-t-current),
// so it reads correctly on any button. size = diameter in px.
export function Spinner({ size = 14, className = "" }: { size?: number; className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`inline-block shrink-0 rounded-full border-2 border-current border-t-transparent animate-spin ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
